import Vue from 'vue';
import VueI18n from 'vue-i18n';

import zhTW from './zh-TW.json';
import ko from './ko-KR.json';

Vue.use(VueI18n);

export default new VueI18n({
  locale: 'ko',
  fallbackLocale: 'ko',
  messages: {
    'zh-TW': zhTW,
    ko,
  },
});



// WEBPACK FOOTER //
// ./src/i18n/index.js